<template>
    <div>
      <div class="grid-content maintitle">
        <span>{{ $t("message.隐私政策编辑") }}</span>
      </div>
  
      <div class="topContainer">
        <div class="grid-content content-margin topFix">
          <div class="buttonarea">
            <el-link :underline="false">
              <el-button size="medium" round @click.native="goBack">
                <i class="iconfont">&#xe600;</i>
                {{ $t("message.返回") }}
              </el-button>
            </el-link>
            <el-link :underline="false" v-show="!isEditMode && !isInit">
              <el-button size="medium" round @click="isEditMode = true">
                <i class="iconfont">&#xe618;</i>
                {{ $t("message.修改") }}
              </el-button>
            </el-link>
            <el-link :underline="false" v-show="isEditMode">
              <el-button size="medium" round @click="doSave" type="primary">
                <i class="iconfont">&#xe769;</i>
                {{ $t("message.保存") }}
              </el-button>
            </el-link>
            <el-link :underline="false" v-show="!isInit">
              <el-button size="medium" round @click.native="refresh">
                <i class="iconfont">&#xe667;</i>
                {{ $t("message.刷新") }}
              </el-button>
            </el-link>
          </div>
        </div>
      </div>
  
      <div class="grid-content subtitle">
        <span>{{ $t("message.隐私政策编辑") }}</span>
      </div>
      <div class="grid-content content-margin">
        <table class="simpleRow">
          <tr v-if="privacy.id > 0">
            <td style="min-width:120px">
              <span class="simpleLabel">{{ $t("message.文章ID") }}</span>
            </td>
            <td>
              <el-input
                :disabled="true"
                v-model="privacy.id"
                readonly
                size="mini"
                placeholder=""
                style="width: 175px"
              >
              </el-input>
            </td>
          </tr>
  
          <tr>
            <td>
              <span class="simpleLabel">{{ $t("message.隐私政策标题") }}</span>
            </td>
            <td>
              <el-input
                :disabled="!isEditMode"
                v-model="privacy.name"
                size="mini"
                placeholder=""
                style="width: 500px"
              >
              </el-input>
            </td>
          </tr>
  
          <tr>
            <td>
              <span class="simpleLabel">{{ $t("message.是否使用该隐私政策") }}</span>
            </td>
            <td>
              <el-radio-group
                :disabled="!isEditMode"
                v-model="privacy.validFlag"
                size="mini"
              >
                <el-radio :label="true">{{ $t("message.生效") }}</el-radio>
                <el-radio :label="false">{{ $t("message.不生效") }}</el-radio>
              </el-radio-group>
            </td>
          </tr>

          <tr>
            <td>
              <span class="simpleLabel">{{ $t("message.协议类型") }}</span>
            </td>
            <td>
              <el-select size="small" v-model="privacy.type" :placeholder="$t('message.请选择')" :disabled="!isEditMode" clearable>
                    <el-option
                      v-for="item in typeOptions"
                      :key="item.value"
                      :label="item.label"
                      :value="item.value">
                    </el-option>
                  </el-select>
            </td>
          </tr>
  
          <tr>
            <td>
              <span class="simpleLabel">隐私政策版本</span>
            </td>
            <td>
              <el-input-number
                :min="0"
                :disabled="!isEditMode"
                size="mini"
                v-model="privacy.version"
              ></el-input-number>
              <!-- <el-input
                :disabled="!isEditMode"
                size="mini"
                v-model="privacy.version"
                :placeholder="$t('message.隐私政策版本')"
                style="width: 110px"
              >
              </el-input> -->
            </td>
          </tr>
          <tr>
            <td style="vertical-align: top;">
              <span class="simpleLabel" style="">{{ $t("message.协议内容") }}</span>
            </td>
             <td>
             <!-- <el-upload :disabled="!isEditMode" style="margin-bottom: 10px;" action :on-change="handleChange1" with-credentials :multiple="false" :before-upload="beforeUpload1">
               <el-button slot="trigger" size="small" type="primary">选取word文件</el-button>
             </el-upload> -->
  
              <wangeditor @savereturn='saveArticle' @savereturntxt='saveArticleTxt' :init='initArticleDate()' :geteditor='geteditor' :isedit='isEditMode'>
              </wangeditor >
            </td>
          </tr>
  
        </table>
      </div>
  
      <shade v-if="showResourceStore > 0">
        <resource-store
          :shadeShow="showResourceStore > 0"
          @onClick="onResourceStoreCallback"
          :appID="privacy.appid"
        ></resource-store>
      </shade>
      <!-- <el-dialog
    title="预览"
    :visible.sync="htmlflag"
    style="margin-bottom:0;"
    width="375px"
    >
    <div v-html="filterdata" style="height:500px;overflow:auto;" class="htmlshow">
  
    </div>
    <span slot="footer" class="dialog-footer">
      <el-button @click="htmlflag = false">取 消</el-button>
      <el-button type="primary" @click="htmlflag = false">确 定</el-button>
    </span>
  </el-dialog> -->
  
      <el-dialog
        :title="$t('message.删除确认')"
        :visible.sync="deleteDialogVisible"
        width="300px"
        :modal="false"
        center
        :before-close="handleClose"
      >
        <i class="iconfont">&#xe766;</i>
        <span>{{ $t("message.请确认是否删除") }}</span>
        <span slot="footer" class="dialog-footer">
          <el-button @click="deleteDialogVisible = false">{{
            $t("message.取消")
          }}</el-button>
          <el-button type="primary" @click.native="deleteDataSource">{{
            $t("message.删除")
          }}</el-button>
        </span>
      </el-dialog>
    </div>
  </template>
  
  <script>
  import { topfixfunc } from "@/utils/topFix";
  import shade from "@/components/shade/shade";
  import { rejecthttp, changeflagCLOSED } from "@/utils/request";
  import ResourceStore from "@/components/resourceStore/resourceStore";
  import newcontainer from "@/pages/test/newcontainer";
  import wangeditor from "@/components/wangeditor/wangeditor.vue"
  
  export default {
    name: "privacyDetail",
    components: {
      shade,
      ResourceStore,
      newcontainer,
      wangeditor,
    },
    data() {
      return {
        htmlflag:false,
        tableHeight: 500,
        classifyGroup:[],
        setArticle: null,
        selectedClassify:[],
        checkList:[],
        privacy: {
          appID: 188,
          name: '',
          validFlag: true,
          type:null,
          version: 1,
          content: '',
        },
        
        typeOptions: [
          {
            value: 1,
            label: this.$t('message.隐私协议'),
          },
          {
            value: 2,
            label: this.$t('message.条件条款'),
          },
          {
            value: 3,
            label: this.$t('message.会员细则'),
          },
        ],

        isEditMode: true,
        isInit: true,
        showResourceStore: false,
        showDataSource: false,
        showPreview: false,
        deleteDialogVisible: false,
      };
    },
    mounted: function () {
      // 用来监听el-main滚动事件
      topfixfunc();
      //this.$refs.table.$el.offsetTop：表格距离浏览器的高度 //50表示你想要调整的表格距离底部的高度（你可以自己随意调整），因为我们一般都有放分页组件的，所以需要给它留一个高度
    },
    watch: {},
    methods: {
      handleClassifyChange(value) {
          this.selectedClassify = value;
          if(value.length===0)
          {
            this.privacy.secondcategoryid = null;
            this.privacy.firstcategoryid = null;
          }
          if(value.length===1){
            this.privacy.secondcategoryid = null;
            this.privacy.firstcategoryid = value[0];
          }
          if(value.length===2){
            this.privacy.secondcategoryid = value[1];
            this.privacy.firstcategoryid = value[0];
          }
        },
      beforeUpload1(file) {
          const fileType = file.name.substring(file.name.lastIndexOf('.'))
          if (fileType.toLowerCase() != '.docx') {
              this.$message.error('文件必须为docx类型')
              return false
          }
          },
  
       handleChange1(file,filelist) {
         let formdata = new FormData();
         formdata.append('appid',Number(this.privacy.appID));
         formdata.append('attachment',filelist[0].raw);
        rejecthttp(true, "post", "/manage/article/uploadword", formdata, this, (doc) => {
            changeflagCLOSED(doc, 1, this);
            if (doc.data.Code == "MSGKEY_OK") {
              this.setArticle(doc.data.data.htmlText);
            }
          });
      },
      beforeUpload2(file) {
          // const fileType = file.name.substring(file.name.lastIndexOf('.'))
          // if (fileType.toLowerCase() != '.pdf') {
          //     this.$message.error('文件必须为pdf类型')
          //     return false
          // }
          },
  
       handleChange2(file,filelist) {
        //  let formdata = new FormData();
        //  formdata.append('appid',Number(this.privacy.appid));
        //  formdata.append('attachment',filelist[0].raw);
        // rejecthttp(true, "post", "/manage/privacy/uploadword", formdata, this, (doc) => {
        //     changeflagCLOSED(doc, 1, this);
        //     if (doc.data.Code == "MSGKEY_OK") {
        //       this.setArticle(doc.data.data.htmlText);
        //     }
        //   });
      },
  
      saveArticle(content,f) {
        console.log(f)
        if(f){
      this.htmlflag=true
  
        }
        // console.log(rule)
        if(this.isEditMode)
        {
  
            // this.privacy.content = content;

        //   console.log("文章内容:"+encodeURIComponent(content));
             this.privacy.content = encodeURIComponent(content);
        }
      },
      //  #region 
      saveArticleTxt(content) {
        // console.log(rule)
        if(this.isEditMode)
        {

        }
      },
  
      initArticleDate() {
        var body = { html: this.privacy.content };
        console.log(body);
        return body;
      },
  
      // #endregion 
      onShowDataSorce() {
        this.showDataSource = true;
      },
  
      doShowResourceStore(type) {
        if (!this.isEditMode) return;
        this.showResourceStore = type;
      },
      onResourceStoreCallback(doc) {
        console.log(doc);
        if (doc) {
          switch (this.showResourceStore) {
            case 1:
              this.privacy.bannerurl = doc.resourceID;
              break;
            case 2:
              this.privacy.picurl = doc.resourceID;
              break;
            case 3:
              this.privacy.pdfurl = doc.resourceID;
              break;
          }
          this.showResourceStore = 0;
        } else {
          this.showResourceStore = 0;
        }
      },
      goBack() {
        this.$router.go(-1); //返回上一层
      },
  
      doSave() {
        // this.privacy.tagList = [];
        // this.checkList.forEach((v,i,arr)=>{
        //   var obj = {id:v};
        //   this.privacy.tagList.push(obj);
        // })
        this.isEditMode = false;
        if (this.isInit) {
          rejecthttp(true, "post", "/manage/policy/add", this.privacy, this, (doc) => {
            changeflagCLOSED(doc, 1, this);
            if (doc.data.Code == "MSGKEY_OK") {
            }
          });
        } else {
          rejecthttp(true, "post", "/manage/policy/update", this.privacy, this, (doc) => {
            changeflagCLOSED(doc, 1, this);
            if (doc.data.Code == "MSGKEY_OK") {
            }
          });
        }
      },
  
      refresh() {
        this.getArticleDetial();
        // this.getClassifyGroup();
        // this.getTagList();
      },
  
      getClassifyGroup() {
        this.$http
          .get("/manage/classify/getvalidlist", {
            params: {
              appid: this.privacy.appid
            },
          })
          .then((doc) => {
            if (doc.data.Code != "MSGKEY_OK") {
              this.$message({
                type: "error",
                message: doc.data.Message,
              });
            } else {
              this.classifyGroup = [];
              doc.data.data.firstGroup.forEach((value,index,array) => {
                var filterlist = doc.data.data.secondGroup.filter((a)=>{if(a.parentid===value.classifyid)return true});
                var children = [];
                filterlist.forEach((value,index,array)=>{
                  var obj = {'value':value.classifyid,'label':value.name};
                  children.push(obj);
                })
                var obj;
                if(children.length>0){
                  obj = {'value':value.classifyid,'label':value.name,'children':children};
                }else{
                  obj = {'value':value.classifyid,'label':value.name};
                }
                this.classifyGroup.push(obj);
              });
            }
          });
      },
  
      getArticleDetial() {
        if (!this.privacy.id) {
          return;
        }
        this.$http
          .get("/manage/policy/getdetail", {
            params: {
              id: this.privacy.id,
            },
          })
          .then((doc) => {
            if (doc.data.Code != "MSGKEY_OK") {
              this.$message({
                type: "error",
                message: doc.data.Message,
              });
            } else {
              this.privacy = doc.data.data;
            //   this.checkList = [];
            //   this.privacy.tagList.forEach((v,i,arr)=>{
            //     this.checkList.push(v.id);
            //   })
              this.selectedClassify = [];
              if(this.privacy.firstcategoryid!=null){
                this.selectedClassify.push(this.privacy.firstcategoryid);
              }
              if(this.privacy.secondcategoryid!=null){
                this.selectedClassify.push(this.privacy.secondcategoryid);
              }
              this.setArticle(this.privacy.content);
            }
          });
      },
  
      getTagList() {
        this.$http
          .get("/manage/interestedtag/taglist", {
            params: {
              appid: this.privacy.appid,
            },
          })
          .then((doc) => {
            if (doc.data.Code != "MSGKEY_OK") {
              this.$message({
                type: "error",
                message: doc.data.Message,
              });
            } else {
              this.tagList = doc.data.data;
            }
          });
      },
  
      geteditor(setArticle){
        this.setArticle = setArticle;
      },
      handleClose(done) {
        // 空函数, 防止dialog被不小心关闭
      },
    },
  
    created() {
      this.privacy.appID = this.$route.query.appid ? Number(this.$route.query.appid ): 0;
      if (this.$route.query.id) {
        this.privacy.id = this.$route.query.id;
        this.isEditMode = this.$route.query.isEditMode ? true : false;
        this.isInit = false;
      }
      this.refresh();
    },
  
    computed: {
      filterdata() {
       let v = this.privacy.content
       //pt转rpx
       try{
        v = v.replace(/:.*?pt/g, ($1) => {
         $1 = $1.replace(/pt/g, 'rpx')
         return $1
        })
        v = v.replace(/&lt;/g, '<')
        v = v.replace(/&gt;/g, '>')
        //pt转rpx
        v = v.replace(/(width|height)\s*=\s*("|').*pt("|')/g, ($1) => {
         $1 = $1.replace(/pt/g, 'rpx')
         return $1
        })
        v=v.replace(/<(\/div|div).*?>/g,'')
        //富文本图片大小设置自适应
        v=v.replace(/\<img/gi, '< img style="width:100%;height:auto" ')
        //去掉包裹的div
  
        this.search+=''
        let value='<span style="color:red">'+this.search+'</span>'
        let reg = new RegExp(this.search,"g");
        //替换search元素
        if(this.search){
          try{
           v=v.replace(reg,value)
          }catch(e){
           console.log(e)
          }
  
        }
        // let idlist=[{url:'',content:'',id:'to'+Math.random(),toid:''}]
        // console.log(v)
        // //<pre><code class="Bash">#herf=1&amp;toid=5#</code></pre>
        // //herf自己的地址 用来跳转到toid的位置可以为空 点击范围需要用#herf=1&toid=5# 中间是内容herf=&toid=#
        // v=v.replace(/<pre><code.*?>#herf=.*?&amp;toid=.*?#<\/code><\/pre>/g,function($1){
        //  let idstart=$1.indexOf('herf=')
        //  let toidstart=$1.indexOf('&amp;toid=')
        //  let end=$1.lastIndexOf('#')
        //  let c=$1.slice(idstart+5,toidstart)
        //  let d=$1.slice(toidstart+10,end)
        //  idlist.push({url:$1,content:'',id:c?'to'+c:'',toid:d?'to'+d:''})
        //  return $1
        // })
        // let arr=v.split(/<pre><code.*?>#herf=.*?&amp;toid=.*?#<\/code><\/pre>/g)
        v=v.replace(/<pre><code class="Bash">/g,'')
        v=v.replace(/<\/code><\/pre>/g,'')
        v=v.replace(/target="_blank"/g,'')
        v=v.replace(/< img/g,'<img')
        //v='<img style="width:100%;height:auto"  src="https://walmart-1311734027.cos.ap-shanghai.myqcloud.com/188/png/LC20220606153227830cf0537ef-bd63-43fb-aba2-a80b1a5fdd9a188.png" width="438.36566px" height="225.69992px"/>'
        // idlist.forEach((item,index)=>item.content=arr[index])
        return v
       }catch(e){
        //TODO handle the exception
        console.error(e)
       }
  
      }
    },
    // // 隐藏固定栏
    // destroyed () {
    //   var topFix=document.querySelector('.topFix')
    //   // 固定栏隐藏
    //   topFix.style.display='none'
    // }
  };
  </script>
  
  <style scoped>
  .el-table /deep/ td {
    user-select: text !important;
  }
  div /deep/ .el-dialog{
    position:absolute;top:50%!important;left:50%;transform:translate(-50%, -50%)!important;
  }
  .shade-chil {
    width: 1160px;
    height: 680px;
    /* background-color: RGB(249,249,249); */
    border-radius: 12px;
    box-shadow: 4px 4px 12px #888888;
    background-image: linear-gradient(#f9f9f9, #fdfdfd, #f0f0f0, #f3f3f3);
  
    border-left: 1px solid #bbb;
    border-top: 1px solid #bbb;
    border-right: 1px solid #888;
    border-bottom: 1px solid #888;
    padding: 20px;
    position: relative;
    z-index: 100;
    -moz-user-select: none;
    -o-user-select: none;
    -khtml-user-select: none;
    -webkit-user-select: none;
    -ms-user-select: none;
    user-select: none;
  }
  div ::-webkit-scrollbar{
    display: none!important;
  }
  
  
  </style>
  


// WEBPACK FOOTER //
// src/pages/privacy/privacyDetail.vue